<div class="border-0 px-4 py-1 scroll-container"
     ref="VerificationServicesConfigurations">
  <NavigationBackButton/>
  <div class="card-header card-header-primary card-nav-tabs shadow rounded-lg mt-2">
    <div class="nav-tabs-navigation">
      <div class="nav-tabs-wrapper">
        <ul class="nav nav-tabs" data-tabs="tabs">
          <li class="rounded-lg me-2 nav-item">
            <a class="text-white text-decoration-none fs-5 fw-bold nav-link"
               href="#profile" data-toggle="tab">
              <span><i class="bi bi-folder-check fs-4 me-2"></i></span>Assign Verification Services To Projects
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Services Card -->
  <div class="glassy-bg rounded-lg border-0 shadow mt-2">
    <div class="card-body rounded-lg shadow">

      <!-- Services List -->
      <div class="d-flex flex-column gap-3 p-2">
        <div v-for="service in services"
             :key="service.id"
             class="card shadow rounded-lg border-light service-card">

          <div class="card-body cursor-pointer hover-bg"
               data-bs-toggle="modal"
               data-bs-target="#assign_workflow_to_template"
               @click="selected_service = service">

            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <p class="fw-bold mb-1 text-xs">{{ service.name }}</p>
                <p class="text-muted text-xxs mb-0">{{ service.description }}</p>
              </div>
              <div class="text-end">
                <span class="fw-bold text-dark">
                  {{ (service.price ?? 0).toLocaleString('en-ZA', { style: 'currency', currency: 'ZAR' }) }}
                </span>
              </div>
            </div>

            <!-- Assigned Projects -->
            <div v-if="get_assigned_project_names(service).length > 0"
                 class="mt-3 d-flex align-items-center gap-2 flex-wrap justify-content-end">

              <button class="btn btn-sm text-xs shadow-sm" type="button">
                {{ get_assigned_project_names(service).length }} project{{ get_assigned_project_names(service).length !== 1 ? 's' : '' }} assigned
              </button>

              <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                      data-bs-toggle="modal"
                      data-bs-target="#assign_workflow_to_template"
                      @click.stop="selected_service = service">
                Manage Assignments
              </button>
            </div>

            <div v-else class="mt-2">
              <small class="text-muted text-xs">Click to assign projects</small>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!--Assign/Unassign Modal -->
<teleport to="body">
<div v-show="selected_service">
  <teleport to="body">
  <div class="modal fade" id="assign_workflow_to_template" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content bg-white rounded-3">
        <div class="modal-header border-bottom-0 custom-header text-white">
          <p class="modal-title text-white text-xxs">Select projects to assign</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body py-4">
          <GlobalTable
            v-if="projects.length > 0"
            :headers="['ID','Name']"
            :data="projects"
            table_id="project_assignments_table">
            <template #actions="{ row }">
              <div class="form-check form-switch">
                <input class="form-check-input"
                       type="checkbox"
                       :id="'switch_' + row.id"
                       :checked="is_project_assigned(row.id)"
                       @change="handle_toggle_project(row.id)">
              </div>
            </template>
          </GlobalTable>
        </div>
      </div>
    </div>
  </div>
  </teleport>
</div>
</teleport>
